import { UserInfo } from '@user/userInfo.js';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper/core';
import { getTournamentJson } from '../games/data';
import { getJackpotsJson } from '../panels/jackpots.js';

export function observeModal(slider) {
  const observer = new MutationObserver((mutations) => {
    const sliderEl = slider.el;
    mutations.forEach(({ type, attributeName, target }) => {
      if (type === 'attributes' && attributeName === 'class') {
        let action = null;
        if (target?.classList?.contains('modal-open') || target?.classList.contains('gamepopup-open')) {
          if (!sliderEl?.classList?.contains('stopped')) action = 'stop';
        } else if (sliderEl?.classList?.contains('stopped')) action = 'start';
        if (action) {
          if (action == 'stop') {
            slider.autoplay.stop();
            sliderEl.classList.add('stopped');
          } else {
            slider.autoplay.start();
            sliderEl.classList.remove('stopped');
          }
          if (slider.pagination?.bullets) {
            [...slider.pagination.bullets].forEach((el) => {
              let currentClass = el.getAttribute('class');
              if (currentClass.includes(action == 'stop' ? 'tns-nav-active' : 'tns-nav-disactive')) {
                currentClass = currentClass.replace(action == 'stop' ? ' tns-nav-active' : ' tns-nav-disactive', '');
                currentClass += action != 'stop' ? ' tns-nav-active' : ' tns-nav-disactive';
                el.setAttribute('class', currentClass);
              }
            });
          }
        }
      }
    });
  });
  observer.observe(document.querySelector('body'), {
    attributes: true,
    attributeFilter: ['class']
  });
}

export async function initSlider() {
  const moduleMD5 = await import('../tools/md5.js'),
    moduleBasicFunc = await import('../tools/basic-functions.js'),
    moduleFootnote = await import('../footnote/footnote.js');
  //config

  let langLocale = _CMS_LOCALE != '' ? _CMS_LOCALE : _CMS_LANGUAGE,
    jsonURL = '/' + langLocale + '/json/sliders';

  let sliderEl = document.querySelector('#slider'),
    sliderElBody = sliderEl.querySelector('.sliders-body'),
    destination = sliderEl.getAttribute('data-destination'),
    itemHTML = sliderElBody.innerHTML,
    userProfile = _CMS_USER_PROFILE ?? [];
  // jsonURL = '/' + _CMS_LANGUAGE + '/json/sliders';
  // jsonURL = '/' + jsonCmsLang + '/json/sliders';
  if (_CMS_MOBILE) {
    sliderEl.parentNode.appendChild(createEL('<div class="slider-overflow-background"></div>'));
  }
  if (_CMS_USER_SESSION_ACTIVE == 1 && userProfile && Array.isArray(userProfile)) {
    userProfile.push(moduleMD5.md5('s-active'));
    userProfile.push(moduleMD5.md5('d-' + _CMS_USER_NO_DEP));
  } else {
    userProfile = moduleMD5.md5('s-inactive');
  }
  const data = await moduleBasicFunc.getJSON(jsonURL);
  //const data = await moduleBasicFunc.getJSON('../../slider-data.json');
  sliderElBody.innerHTML = '';
  if (Array.isArray(data.slides)) {
    for (let i = 0, len = data.slides.length; i < len; i++) {
      let item = data.slides[i];
      if (item.destination == destination) {
        if (
          item.country_restriction_type == 'Global' ||
          (item.country_restriction_type == 'Allowance mode' &&
            ((item.country_restriction_config == '' && sliderEl.getAttribute('data-mode') == 'preview') ||
              item.country_restriction_config.indexOf(_CMS_USERIP) >= 0)) ||
          (item.country_restriction_type == 'Restriction mode' &&
            item.country_restriction_config.indexOf(_CMS_USERIP) == -1)
        ) {
          let profileCompability = false;
          if (
            item.user_restriction_type != 'Unrestricted' &&
            item.user_restriction_type != '' &&
            item.user_restriction_config != ''
          ) {
            let itemProfile = item.user_restriction_config.split(',');
            for (let i = 0, len = itemProfile.length; i < len; i++) {
              let value = itemProfile[i];
              if (userProfile.includes(value) || value == userProfile) {
                profileCompability = true;
              }
            }
          }
          if (
            item.user_restriction_type == 'Unrestricted' ||
            item.user_restriction_type == '' ||
            (item.user_restriction_type == 'User allowance mode' && profileCompability) ||
            (item.user_restriction_type == 'User restriction mode' && !profileCompability)
          ) {
            //generate slider
            window.tabActive = true;
            sliderElBody.appendChild(createEL(itemHTML));
            let currentItem = sliderElBody.lastChild;
            currentItem.setAttribute('id', item.cms_id);

            if (sliderEl.getAttribute('data-device') == 'web') {
              currentItem.querySelector('.slide-background-image').style.backgroundImage =
                'url(' + item.desktop_background + ')';
              currentItem.querySelector('.slide-images-holder-layer-background').innerHTML =
                "<img src='" +
                item.desktop_background +
                "' data-src='" +
                item.desktop_background +
                "' class='notLazy'>";

              if (/chrome/i.test(navigator.userAgent)) {
                currentItem.querySelector('.slide-background-image').classList.add('chrome');
              }

              window.addEventListener('focus', function () {
                window.tabActive = true;
              });

              window.addEventListener('blur', function () {
                window.tabActive = false;
              });
            }

            if (sliderEl.getAttribute('data-device') == 'mobile') {
              currentItem.querySelector('.slide-thumb').style.backgroundImage =
                sliderEl.getAttribute('data-device') == 'web'
                  ? 'url(' + item.desktop_background + ')'
                  : 'url(' + item.mobile_background + ')';
            }

            if (item.foreground) {
              let foreground = new DOMParser().parseFromString(item.foreground, 'text/html');

              if (
                foreground.body.querySelector('.desktop') !== null &&
                currentItem.querySelector('.slide-images-holder-desktop-layers')
              ) {
                currentItem
                  .querySelector('.slide-images-holder-desktop-layers')
                  .appendChild(foreground.body.querySelector('.desktop'));
              }

              if (
                foreground.body.querySelector('.mobile') !== null &&
                currentItem.querySelector('.slide-images-holder-mobile-layers')
              ) {
                currentItem
                  .querySelector('.slide-images-holder-mobile-layers')
                  .appendChild(foreground.body.querySelector('.mobile'));
              }

              if (foreground.body.querySelector('.jackpot') !== null) {
                currentItem.querySelector('.slide-images-holder-jackpot').classList.add('active');
                currentItem.classList.add('slide-jackpot');
                currentItem.setAttribute(
                  'data-jackpotgameid',
                  parseInt(foreground.body.querySelector('.jackpot').getAttribute('data-game-id'))
                );
              }
            }

            currentItem.querySelector('.slide-legalinfo').innerHTML = item.foreground;
            currentItem.querySelector('.slide-title').innerHTML = moduleBasicFunc.decodeHTML(item.title);
            currentItem.querySelector('.slide-description').innerHTML = item.description;

            if (currentItem.querySelector('.slide-link')) {
              if (!item.mobile_url.startsWith('ids')) {
                currentItem.querySelector('.slide-link').setAttribute('href', item.mobile_url);
              } else {
                const { initGameModePopupHandler } = await import('../games/mobile/game-window/game-window');
                currentItem.querySelector('.slide-link').removeAttribute('href');
                currentItem.querySelector('.slide-link').classList.add('js-run-mobile');
                let gameIdList = item.mobile_url.replace(/'/g, '').replace('ids=', '').split(',');
                if (gameIdList.length > 1) {
                  currentItem.querySelector('.slide-link').setAttribute('data-game-id', gameIdList[1]);
                } else {
                  currentItem.querySelector('.slide-link').setAttribute('data-game-id', gameIdList[0]);
                }
                currentItem.querySelector('.slide-link').addEventListener('click', (e) => {
                  e.preventDefault();
                  initGameModePopupHandler(e.currentTarget.getAttribute('data-game-id'));
                });
              }
            }
            if (currentItem.querySelector('.slide-buttons')) {
              currentItem.querySelector('.slide-buttons').innerHTML = item.desktop_buttons;
              if (currentItem.querySelector('.js-run-game')) {
                let gameId = currentItem.querySelector('.js-run-game').getAttribute('data-game-id');
                if (isNaN(gameId)) {
                  let gameIdList = gameId.split(',');
                  currentItem.querySelector('.js-run-game').setAttribute('data-game-id', gameIdList[0]);
                }
              }
            }
            if (item.footnote != '') {
              let itemFootnote = currentItem.querySelector('.slide-legalinfo');
              itemFootnote.innerHTML = moduleBasicFunc.decodeHTML(item.footnote);
              itemFootnote.setAttribute('title', itemFootnote.textContent);
            } else {
              currentItem
                .querySelector('.slide-legalinfo')
                .parentNode.removeChild(currentItem.querySelector('.slide-legalinfo'));
            }
            //preview watermark
            if (
              sliderEl.getAttribute('data-mode') == 'preview' &&
              item.country_restriction_config == '' &&
              item.country_restriction_type == 'Allowance mode'
            ) {
              currentItem.classList.add('preview-mode');
            }
          }
        }
      }
    }
  }
  initSliderGamesTournaments();
  stickyWelcomeOffer(sliderElBody);
  if (sliderEl.getAttribute('data-device') == 'web') {
    await initSliderWeb();
  } else {
    await initSliderMobile();
  }
  moduleFootnote.initFootnotePopup(sliderEl);
}

async function initJackpot(jackpotData) {
  clearInterval(window.jackpotAmount);
  clearInterval(window.jackpotNextAmount);
  clearTimeout(window.jackpotTimeout);

  document.body.querySelectorAll('.slide').forEach((el) => {
    el.classList.remove('transition-end');
  });
  let currentItem = document.body.querySelector('.swiper-slide-active');
  if (currentItem) {
    currentItem.classList.add('transition-end'); // blur hack with opacity
  }

  const generateRandomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min) + min);
  };

  if (currentItem && currentItem.classList.contains('slide-jackpot')) {
    let jackpotGameID = parseInt(currentItem.getAttribute('data-jackpotgameid'));
    let jackpotElement = document.querySelector('[data-jackpotgameid="' + jackpotGameID + '"]');
    let jackpotItem = jackpotData.jackpots ? jackpotData.jackpots : jackpotData;
    let jackpotItemData = jackpotItem.find(
      ({ GameId, jackpotsSum }) => GameId == jackpotGameID && (jackpotsSum == true || jackpotsSum == null)
    );

    if (!jackpotItemData) return;

    let jackpotMax = jackpotItemData.JackpotWinAmount;
    let jackpotCurrency = jackpotItemData.currencyCode;
    let jackpotGrowth = jackpotItemData.GrowthPerSecond ? parseFloat(jackpotItemData.GrowthPerSecond) : null;
    let jackpotHalf = parseFloat(jackpotMax / 2);
    let jackpotCurrent = jackpotElement.getAttribute('data-jackpotcurrent')
      ? parseFloat(jackpotElement.getAttribute('data-jackpotcurrent'))
      : jackpotHalf;
    let jackpotInterval = !isNaN(jackpotElement.getAttribute('data-jackpotinterval'))
      ? parseInt(jackpotElement.getAttribute('data-jackpotinterval'))
      : 1;

    let interval = 0;
    let jackpotNumberInterval = jackpotHalf / 100;
    let jackpotMaxInterval = parseFloat(jackpotMax - jackpotNumberInterval);
    let intervalMax = 6000;

    const addJackpot = () => {
      if (jackpotInterval <= 100 || isNaN(jackpotInterval)) {
        if (interval <= intervalMax) {
          if (window.tabActive) {
            if (jackpotGrowth === null && jackpotCurrent >= jackpotMaxInterval) {
              jackpotCurrent = jackpotCurrent + 0.2;
            } else {
              jackpotCurrent =
                jackpotCurrent <= jackpotMaxInterval
                  ? Math.floor((jackpotCurrent + jackpotNumberInterval) * 100) / 100
                  : Math.floor((jackpotCurrent + jackpotGrowth) * 100) / 100;
            }

            document.body.querySelectorAll('[data-jackpotgameid="' + jackpotGameID + '"]').forEach((el) => {
              el.querySelector('.slide-images-holder-jackpot').textContent =
                jackpotCurrent.toFixed(2) + ' ' + jackpotCurrency;
              el.setAttribute('data-jackpotcurrent', parseFloat(jackpotCurrent));
            });

            interval = jackpotCurrent <= jackpotMaxInterval ? intervalMax : interval + generateRandomNumber(50, 200);
          } else {
            document.body.querySelectorAll('[data-jackpotgameid="' + jackpotGameID + '"]').forEach((el) => {
              el.querySelector('.slide-images-holder-jackpot').textContent =
                jackpotCurrent.toFixed(2) + ' ' + jackpotCurrency;
            });
          }
        } else {
          interval = 0;

          clearInterval(window.jackpotAmount);
          clearInterval(window.jackpotNextAmount);

          window.jackpotTimeout = setTimeout(
            () => {
              document.body.querySelectorAll('[data-jackpotgameid="' + jackpotGameID + '"]').forEach((el) => {
                el.setAttribute('data-jackpotinterval', parseInt(jackpotInterval + 1));
              });
              window.jackpotNextAmount = setInterval(addJackpot, 50);
            },
            generateRandomNumber(1500, 3000)
          );
        }
      }
    };

    window.jackpotAmount = setInterval(addJackpot, 50);
  }
}

async function initSliderWeb() {
  const jackpotData = await getJackpotsJson();

  SwiperCore.use([Navigation, Pagination, Autoplay]);
  new SwiperCore('#slider', {
    loop: true,
    speed: 300,
    freeMode: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletActiveClass: 'tns-nav-active'
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    on: {
      slideChangeTransitionEnd: () => {
        initJackpot(jackpotData);
      }
    }
  });
}

async function initSliderMobile() {
  const jackpotData = await getJackpotsJson();

  SwiperCore.use([Autoplay]);
  new SwiperCore('.swiper-container', {
    loop: true,
    spaceBetween: 10,
    speed: 300,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false
    },
    breakpoints: {
      700: {
        slidesPerView: 2
      },
      1050: {
        slidesPerView: 3
      },
      1400: {
        slidesPerView: 4
      }
    },
    on: {
      slideChangeTransitionEnd: () => {
        initJackpot(jackpotData);
      }
    }
  });
}

function stickyWelcomeOffer(slider) {
  let welcomeOfferSlidesIds = [2493, 2496, 627, 629, 631, 632, 633, 634, 635, 636, 15698];
  for (let i = 0, len = welcomeOfferSlidesIds.length; i < len; i++) {
    if (slider.querySelector('.slide[id="' + welcomeOfferSlidesIds[i] + '"]')) {
      slider.prepend(slider.querySelector('.slide[id="' + welcomeOfferSlidesIds[i] + '"]'));
    }
  }
}

async function initSliderGamesTournaments() {
  const userInfoInstance = new UserInfo();
  const isLogged = await userInfoInstance.isLoggedAsync();
  if (!isLogged) {
    return;
  }

  let tournaments = await getTournamentJson();

  if (!tournaments || !Array.isArray(tournaments)) {
    return;
  }

  for (let i = 0, len = tournaments.length; i < len; i++) {
    let tournament = tournaments[i];

    if (tournament && Array.isArray(tournament.games)) {
      let tournamentId = tournament.id;

      for (let j = 0, lenJ = tournament.games.length; j < lenJ; j++) {
        let game = tournament.games[j];
        let gameElList = document.querySelectorAll('.sliders .js-run-game[data-game-id="' + game + '"]');

        for (let y = 0, lenY = gameElList.length; y < lenY; y++) {
          gameElList[y].setAttribute('data-tournament-id', tournamentId);
          gameElList[y].classList.add('js-tournament');
          gameElList[y].classList.add('game');
        }
      }
    }
  }
}

const createEL = (domstring) => {
  const html = new DOMParser().parseFromString(domstring, 'text/html');
  return html.body.firstChild;
};
